import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { UserCheck } from 'lucide-react';

export const SendForApprovalDialog = ({ open, onOpenChange, teamMembers, selectedApprover, setSelectedApprover, onSend }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Send for Internal Approval</DialogTitle>
      </DialogHeader>
      <div className="space-y-4">
        <div>
          <label className="text-sm font-medium mb-2 block">Select Approver</label>
          <Select value={selectedApprover} onValueChange={setSelectedApprover}>
            <SelectTrigger>
              <SelectValue placeholder="Choose an approver" />
            </SelectTrigger>
            <SelectContent>
              {teamMembers.filter((m) => ['admin', 'manager'].includes(m.role)).map((member) => (
                <SelectItem key={member.user_id} value={member.user_id}>
                  {member.name} ({member.role})
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <p className="text-sm text-muted-foreground">
          The proposal will be sent to the selected approver for review before being sent to the client.
        </p>
        <div className="flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onSend}>
            <UserCheck className="mr-2 h-4 w-4" />
            Send for Approval
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);
